module.exports = __webpack_public_path__ + "img/symbol_9.9aed9d5d.png";